const blueUpgradePath = (membershipInfo, context) => {
  const nightsRequired = membershipInfo.totalNightsToUpgrade;
  const userNights = membershipInfo.noOfNights;
  const pendingNights = Math.max(0, (nightsRequired || 0) - (userNights || 0));
  return {
    maxValue: nightsRequired,
    value: userNights,
    msg: userNights > nightsRequired
      ? context.t('You are about to upgrade, hold on! Please check tomorrow if you account has been upgraded')
      : context.t(['{nights} more night to upgrade', '{nights} more nights to upgrade', 'nights'], { nights: pendingNights }),
  };
};

const MEMBERSHIP_LEVELS = {
  GOLD: 'Gold',
  BLUE: 'Blue',
  PLATINUM: 'Platinum',
  BLACK: 'Black',
}
const MEMBERSHIP_LEVEL_DATA = {
  [MEMBERSHIP_LEVELS.BLUE]: {
    color: '#5683b4',
    upgradePath: blueUpgradePath,
  },
  [MEMBERSHIP_LEVELS.GOLD]: {
    color: '#edb002',
    upgradePath: null,
  },
  [MEMBERSHIP_LEVELS.PLATINUM]: {
    color: '#aaaaaa',
    upgradePath: null,
  },
  [MEMBERSHIP_LEVELS.BLACK]: {
    color: '#000000',
    upgradePath: null,
  },
};

const isValidMemberType = (type) => {
  return Object.values(MEMBERSHIP_LEVELS).includes(type);
}

export {
  MEMBERSHIP_LEVELS,
  MEMBERSHIP_LEVEL_DATA,
  isValidMemberType,
};
